import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { translations } from '../../i18n'
import Loader from '../../components/Loader'

function BlogPreviewSection() {
  const { lang } = useSelector(s => s.rootReducer.langRed)
  const T = translations[lang]
  const { loading, posts = [] } = useSelector(s => s.rootReducer.latestPostsRed)

  if (loading) return <section className='fc-section bg-alt'><Container><Loader /></Container></section>
  if (!posts.length) return null

  const title = (p) => p[`title_${lang}`] || p.title_en
  const excerpt = (p) => p[`excerpt_${lang}`] || p.excerpt_en

  return (
    <section className='fc-section bg-alt'>
      <Container>
        <div className='d-flex justify-content-between align-items-baseline mb-4'>
          <h2 className='section-title mb-0'>{T.blog.latest}</h2>
          <Link to='/blog/' style={{ color: 'var(--teal)', fontSize: '.9rem', fontWeight: 500 }}>
            {T.blog.all_posts} →
          </Link>
        </div>
        <Row className='g-3'>
          {posts.map(post => (
            <Col md={4} key={post.id}>
              <div className='blog-card'>
                {post.image
                  ? <img src={post.image} alt={title(post)} className='blog-card-img' />
                  : <div className='blog-card-img-placeholder'>✍️</div>
                }
                <div className='blog-card-body'>
                  <div className='blog-card-date'>{new Date(post.date).toLocaleDateString(lang === 'it' ? 'it-IT' : 'en-GB', { year: 'numeric', month: 'long', day: 'numeric' })}</div>
                  <div className='blog-card-title'>{title(post)}</div>
                  <div className='blog-card-excerpt'>{excerpt(post)}</div>
                </div>
                <div className='blog-card-footer'>
                  <div>{(post.tags || []).map(tag => <span key={tag.id} className='tag-pill'>{tag.caption}</span>)}</div>
                  <Link to={`/blog/${post.slug}/`} style={{ color: 'var(--teal)', fontSize: '.85rem', fontWeight: 500 }}>{T.blog.read_more} →</Link>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  )
}

export default BlogPreviewSection
